import React, { Component } from 'react';
import { Alert, Button } from 'reactstrap';
import { AgGridReact } from 'ag-grid-react';
export default class BoardsAdminList extends Component {
    constructor(props) {
        super(props);

        document.title = "Boards List";

        this.state = {
            boards: [],
            columnDefs: [
                { field: 'id', headerName: 'Id', filter: true, floatingFilter: true, maxWidth: 100 },
                { field: 'name', headerName: 'Name', filter: true, floatingFilter: true },
                { field: 'typeDescription', headerName: 'Type', filter: true, floatingFilter: true, maxWidth: 100 },
                {
                    field: 'description',
                    headerName: 'Description',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return this.truncateText(params.data.description, 200)
                    },
                    autoHeight: true,
                    cellStyle: { whiteSpace: 'normal', lineHeight: 'normal' }
                },
                {
                    field: 'comments',
                    headerName: 'Comments',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return this.truncateText(params.data.comments, 200)
                    },
                    autoHeight: true,
                    cellStyle: { whiteSpace: 'normal', lineHeight: 'normal' }
                },
                {
                    field: 'isActive',
                    headerName: 'Is Active',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return params.value === true ? 'Yes' : 'No';
                    }
                }
            ],
            defaultColDef: {
                sortable: true,
                autoHeight: true,
                resizable: true,
                floatingFilter: true
            }
        };
    }

    componentDidMount() {
        fetch('/api/boards', {
            method: 'GET'
        })
        .then(resp => resp.json())
        .then(data => {
            this.setState({ boards: data });
        })
    }

    handleRowClick = (id) => {
        this.props.history.push('boards/' + id);
    }

    truncateText = (desc, maxLen) => {
        return (desc && desc.length > maxLen) ? desc.substring(0, maxLen) + ' ...' : desc || ''
    }

    render() {
        return (
            <div>
                <Alert color='info'>
                    <p className='mb-0'>Below is a list of all Boards and Commissions, click one to edit the board's information, manage its meetings, or manage its members.</p>
                </Alert>                
                <br />
                <div style={{ height: "70vh" }}>
                    <div className="ag-theme-alpine" style={{ width: "100%", height: "100%" }}>
                        <AgGridReact
                            ref={this.gridRef} // Ref for accessing Grid's API
                            rowData={this.state.boards} // Row Data for Rows
                            columnDefs={this.state.columnDefs} // Column Defs for Columns
                            defaultColDef={this.state.defaultColDef} // Default Column Properties
                            animateRows={true} // Optional - set to 'true' to have rows animate when sorted or filtered
                            rowSelection='single' // Options - allows click selection of rows
                            onCellClicked={(params) => this.handleRowClick(params.data.id)} // on row click
                            onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                            pagination={true}
                            paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
                        />
                    </div>
                </div>
                <Button onClick={() => this.handleRowClick(0)}>Create New</Button>
            </div>
        )
    }
}